import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompact';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import { errorBoundary } from 'src/app/hocs';
import { segmentAnalyticsEvent, segmentTrack } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import Footer from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  /** @deprecated */
  trackExternalLinkClick: externalLinkDestination => {
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.externalLinkClicked, { externalLinkDestination }));
  },
  dispatchSegmentTrack: (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload)),
});

const connector = connect(mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(setDisplayName('FooterContainer'), connector, errorBoundary)(Footer);
